export const FETCH_LIBRARY_HISTORY_ALL = "FETCH_LIBRARY_HISTORY_ALL";
export const FETCH_LIBRARY_HISTORY_ALL_SUCCESS = "FETCH_LIBRARY_HISTORY_ALL_SUCCESS";
export const FETCH_LIBRARY_HISTORY_ALL_FAIL = "FETCH_LIBRARY_HISTORY_ALL_FAIL";
export const ADD_LIBRARY_HISTORY_SUCCESS = "ADD_LIBRARY_HISTORY_SUCCESS";
export const ADD_LIBRARY_HISTORY_FAIL = "ADD_LIBRARY_HISTORY_FAIL";
export const DELETE_LIBRARY_HISTORY = "DELETE_LIBRARY_HISTORY";
export const UPDATE_LIBRARY_HISTORY_SUCCESS = "UPDATE_LIBRARY_HISTORY_SUCCESS";
export const UPDATE_LIBRARY_HISTORY_FAIL = "UPDATE_LIBRARY_HISTORY_FAIL";
export const FETCH_LIBRARY_HISTORY = "FETCH_LIBRARY_HISTORY";
export const FETCH_LIBRARY_HISTORY_SUCCESS = "FETCH_LIBRARY_HISTORY_SUCCESS";
export const FETCH_LIBRARY_HISTORY_FAIL = "FETCH_LIBRARY_HISTORY_FAIL";